// start:ng42.barrel
export * from './data-access.constants';
export * from './data-access.module';
export * from './data-access.service';
// end:ng42.barrel

